// reducers/changePasswordReducer.js
import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  RESET_CHANGE_PASSWORD_SUCCESS
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  success: null,
  error: null,
  profilePasswordUpdate: false
};

const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return { ...state, loading: true, success: null, error: null, profilePasswordUpdate: false };

    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, loading: false, success: action.payload, error: null, profilePasswordUpdate: true };

    case CHANGE_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case RESET_CHANGE_PASSWORD_SUCCESS:
      return { ...state,error: null,profilePasswordUpdate:false };

    default:
      return state;
  }
};

export default changePasswordReducer;
